export default __webpack_public_path__ + "static/media/policy06_2023.0a3828b7.jpg";